import { MdArrowUpward } from 'react-icons/md';
import { useElasticidadeCruzadaStore } from '../../ElasticidadeCruzada.store';
import styles from './styles.module.scss';

const formatPercent = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
};

export const PotentialGainCard = () => {
  const { marketShareResponse } = useElasticidadeCruzadaStore();

  const potentialGain = marketShareResponse?.insights.potentialGain;

  if (potentialGain === null || potentialGain === undefined) return null;

  return (
    <div className={styles.card}>
      <span className={styles.value}><MdArrowUpward className={styles.arrowIcon} /> {formatPercent(potentialGain)} p.p. de market share</span>
      <p className={styles.description}>em potencial de ganho</p>
    </div>
  );
};
